import { AxiosResponse } from 'axios';
import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { listSuppressedEmailsApi, SuppressedEmail } from 'AwsModule/api/listSuppressedEmailsApi';
import { awsSuppressedEmailsQueryKeys } from 'AwsModule/query/awsQueryKeys';

interface UseListSuppressedEmailsQueryParams {
  domains: string[];
  enabled?: boolean;
}

export const useListSuppressedEmailsQuery = ({
  domains,
  enabled = true,
}: UseListSuppressedEmailsQueryParams) => {
  // Sort + dedupe domains so the cache key is stable regardless of input order.
  const sortedDomains = Array.from(new Set(domains.map((d) => d.toLowerCase())))
    .filter(Boolean)
    .sort();

  const { data, ...query } = useAppQuery<AxiosResponse<SuppressedEmail[]>>({
    queryKey: awsSuppressedEmailsQueryKeys.list({
      identifier: 'useListSuppressedEmailsQuery',
      domainsKey: sortedDomains.join(','),
    }),
    queryFn: ({ token, buildConfig }) =>
      listSuppressedEmailsApi({
        params: { domain: sortedDomains },
        token,
        config: buildConfig(),
      }),
    enabled: enabled && sortedDomains.length > 0,
    staleTime: 30_000,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    suppressedEmails: data?.data ?? [],
    ...query,
  };
};
